
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/month",
      function () {
        return require("private-next-pages/event/month.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/month"])
      });
    }
  